import { useCallback } from 'react';
import { FormikValues } from 'formik';

import { Grid, GridItem, useTheme } from '@chakra-ui/react';

import { TextField } from 'ui/TextField';

interface RefFriendFormProps {
  isTextExist?: boolean;
  formData: FormikValues;
}

const RefFriendForm = ({ isTextExist, formData }: RefFriendFormProps) => {
  const {
    colors: {
      palette: {
        theme: { input: themeStyles },
        dashboard: {
          referFriend: { detailsBlock: styles }
        }
      }
    }
  } = useTheme();

  const { getFieldProps, errors } = formData;

  const getInputStyles = useCallback(
    (isError: boolean) => ({
      border: '1px solid',
      borderColor: isError
        ? themeStyles.inputBrandFieldInvalidBorderColor
        : styles.borderInput,
      borderRadius: 0
    }),
    [themeStyles.inputBrandFieldInvalidBorderColor, styles.borderInput]
  );

  return (
    <Grid
      templateColumns={{
        base: 'repeat(2, 1fr)',
        lg: isTextExist ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'
      }}
      gap='5px'
      w='full'
    >
      <GridItem colSpan={1}>
        <TextField
          {...getFieldProps('givname')}
          placeholder='FIRST NAME'
          onReset={() => {}}
          fontSize='13px'
          inputStyles={getInputStyles(Boolean(errors.givname))}
        />
      </GridItem>
      <GridItem colSpan={1}>
        <TextField
          {...getFieldProps('surname')}
          placeholder='LAST NAME'
          onReset={() => {}}
          fontSize='13px'
          inputStyles={getInputStyles(Boolean(errors.surname))}
        />
      </GridItem>
      <GridItem colSpan={{ base: 2, lg: isTextExist ? 2 : 1 }}>
        <TextField
          {...getFieldProps('phoneOrEmail')}
          placeholder='PHONE or EMAIL'
          onReset={() => {}}
          fontSize='13px'
          inputStyles={getInputStyles(Boolean(errors.phoneOrEmail))}
        />
      </GridItem>
    </Grid>
  );
};

export default RefFriendForm;
